import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { Table, THead, Pagination } from "stories/tables";
import { Checkbox } from "stories/forms";
import { Spinner } from "stories/components"
import { useTranslation } from 'react-i18next';


import './TableAuto.css';

export const TableAuto = ({ 
    checkboxes = false,
    checked = [],
    setChecked,
    filters,
    headers,
    headerColor = "dark",
    headerTextColor, 
    rows,
    className,
    loading,
    pagination = false,
    paginationPrevious,
    paginationNext,
    paginationOffset,
    paginationLimit,
    paginationCount,
    setFilters,
    showRowNumber = false,
    showId = false,
    tableSmall = true,
    tableStriped = true,
    showPaginationLimitSelect = true,
    showVerticalBorders = true,
    sortBackend = true,
    sorting,
    setSorting,
    showHeader,
    name,
    paginationLimitName="limit",
    footerActions = null,
    customOnClick = null,
    onRowClick = null,
    ...rest 
  }) => {
  const [checkedAll, setCheckedAll] = useState(false)
  const { t } = useTranslation();

  
  
    // Ordering
  const getCurrentOrdering = () => {
    if (sortBackend === true) {
      let orderingField = "";
      let directionAsc = true;
      let ordering = filters?.ordering;
      
      if (ordering) {
        if (ordering.includes("-")) {
          directionAsc = false;
        }
        orderingField = ordering.replace("-","")
      }
      
      return {
        field: orderingField,
        directionAsc: directionAsc,
      }
    }
    else {
      return {
        field: sorting?.sortingKey,
        directionAsc: !sorting?.sortingReverse,
      }
    }
  }
  
  const getSortingStatus = (headerObject) => {
    if (headerObject?.sortable === true) {
      const currentOrdering = getCurrentOrdering();
      if (currentOrdering.field === headerObject?.sortingKey) {
        if (currentOrdering.directionAsc) {
          return (
            <i className="fas fa-angle-up"></i>
          )
        }
        else {
          return (
            <i className="fas fa-angle-down"></i>
          )
        }
      }
    }
    return ""
  }
  
  const handleSorting = (header) => {
    let directionAsc = true;
    const currentOrdering = getCurrentOrdering();
    if (currentOrdering?.field === header.sortingKey) {
      directionAsc = !currentOrdering?.directionAsc
    }
    
    if (sortBackend === true) {
      let orderingFilter = header?.sortingKey;
      if (directionAsc === false) {
        orderingFilter = "-"+orderingFilter;
      }
      
      setFilters(s => ({
        ...s,
        ordering: orderingFilter,
      }))
    }
    else {
      setSorting({
        ...header,
        sortingKey: header?.sortingKey,
        sortingReverse: !directionAsc,
      })
    }
  }
  
  // Ordering END
  
  // Checkboxes
  
  const handleChecked = (id) => (e) => {
    
    let _checked = checked;
    const index = _checked.indexOf(id);
    
    if (index > -1) {
      _checked.splice(index, 1);
    }
    else {
      _checked.push(id)
    }
    
    setChecked([
      ..._checked
    ])
    
  }
  
  const handleToggleCheckAll = () => (e) => {
    
    setCheckedAll(s => !s)
    
    if (e?.target?.checked === true) {
      let _checked = []
      rows && rows.map((row, index) => {
        const checkId = row?.checkId ? row?.checkId : null;
        if (checkId) {
          _checked.push(checkId)
        }
        
      })
      
      setChecked([
        ..._checked
      ])
    }
    else {
      setChecked([])
    }
  }
  
  const isChecked = (id) => {
    return checked.reduce((result, item) => {
      if (item === id) { result = true }
      return result
    }, false)
    
  }
  
  // Checkboxes END
  
  const renderHeader = () => {
    return headers && headers.filter(item => {return item?.visible!==false}).map((header, index) => {
      if (header?.sortable) {
        return (
          <th key={index} className={showHeader}><a className={`table_header_link table_header_link_sortable ${showHeader}`} onClick={() => handleSorting(header)}>{header?.label} {getSortingStatus(header)}</a></th>
        )
      }
      else {
        return (
          <th key={index}>{header?.label}</th>
        )
      }
      
    })
  }
  
  const getVisibleColumnCount = () => {
    let count = headers.filter((item) => item?.visible !== false).length;
    if (showRowNumber) count += 1;
    if (showId) count += 1;
    if (checkboxes) count += 1;
    return count;
  };

  const renderRows = () => {
    if (!rows || rows.length === 0) {
      return (
        <tr><td colSpan={2+headers.length}>No results</td></tr>
      )
    }
    
    return rows && rows.map((row, index) => {
      if (row?.isExpandedDetail) {
        return (
          <tr key={row?.rowKey ?? row?.id ?? `expanded-${index}`} className="table-auto-expanded-row">
            <td colSpan={getVisibleColumnCount()}>
              {row.expandedContent}
            </td>
          </tr>
        );
      }
      /*
      className={`${tableStriped && index % 2 === 1 && "bg-secondary"}`}
      */
      
      const checkId = row?.checkId ? row?.checkId : index;
      const checked = isChecked(checkId);
      if (row?.subtitle) {
        return (
          <tr key={index} className={row?.className}>
            <td>
            
            </td>
          </tr>
        )
      }
      else {
        const rowClickable = typeof onRowClick === "function";
        const trClass = [row?.className, rowClickable ? "table-auto-row--clickable" : ""]
          .filter(Boolean)
          .join(" ");
        const handleTrClick = (e) => {
          if (!rowClickable) return;
          if (e.target.closest("button, a, input, select, textarea, [role='button'], label")) return;
          onRowClick(row, index);
        };
        return (
          <tr key={row?.rowKey ?? index} className={trClass || undefined} onClick={rowClickable ? handleTrClick : undefined}>
            {showRowNumber && (
              <td>{index+1+ Number(paginationOffset)}</td>
            )}
            { showId && (
              <td>{row?.id}</td>
            )}
            { checkboxes && (
              <td>
                {row?.isSubtitle === true ? (
                  <>&nbsp;</>
                ) : (
                  <Checkbox 
                    id={`id_checkbox_${index}`}
                    name={`checkbox_${index}`}
                    checked={checked}
                    value={`checkbox_${index}`}
                    onChange={handleChecked(checkId)}
                  />
                )}
              </td>
            )}
            {headers && headers.filter(item => {return item?.visible!==false}).map((header, j) => (
              <td
                key={j}
                onClick={(event) => {
                  if (!customOnClick) return;
                  if (event.target.closest("button, a, input, select, textarea, [role='button'], label")) return;
                  customOnClick(row?.id, row?.related_model_type, row?.related_model?.ticker_symbol, row?.typeOriginal, row);
                }}
                style={customOnClick && !row?.isHistoryRow ? {cursor: 'pointer'} : undefined}
                className={`${row[header?.key]?.className ? row[header?.key]?.className : ""}`}
              >
                {row[header?.key]?.content ? row[header?.key]?.content : row[header?.key]}
              </td>
            ))}
          </tr>
        )
      }
    })
  }

  const hasRows = Array.isArray(rows) && rows.length > 0;
  return (
    <>
      <div style={{ position: "relative" }}>
        <Table
          className={`table_auto ${tableSmall ? "table-sm" : ""} ${tableStriped ? "table-striped" : ""} ${className ? className : ""}`}
          showVerticalBorders={showVerticalBorders}
          name={name}
        >
          <THead color={headerColor}>
            <tr>
              { showRowNumber && (
                <th>
                #
                </th>
              )}
              { showId && (
                <th>
                ID
                </th>
              )}
              { checkboxes && (
                <th>
                  <Checkbox
                    id="checkbox_all"
                    name="checkbox_all"
                    value="checkbox_all"
                    checked={checkedAll}
                    onChange={handleToggleCheckAll()}
                  />
                </th>
              )}
              { renderHeader()}
            </tr>
          </THead>
          <tbody>
          { loading && !hasRows ? (
            <tr><td colSpan={headers && headers.length +1} className="text-center"><Spinner name="loading_spinner" className="mt-2"/></td> </tr>
          ) :
            renderRows()
          }
          </tbody>
        </Table>
        { loading && hasRows && (
          // Päivityksen aikana spinneri overlay:nä, jotta rivit ja sivutus pysyvät paikoillaan
          // eikä koko sivun korkeus muutu (estetään scrollbar:in vilkkuminen).
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              top: 0, left: 0, right: 0, bottom: 0,
              background: "rgba(255, 255, 255, 0.5)",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              paddingTop: "40px",
              pointerEvents: "none",
              zIndex: 1,
            }}
          >
            <Spinner name="loading_spinner_overlay" />
          </div>
        )}
      </div>
      { pagination && (
        <Pagination
          paginationPrevious={paginationPrevious}
          paginationNext={paginationNext}
          paginationOffset={paginationOffset}
          paginationLimit={paginationLimit}
          paginationCount={paginationCount}
          setFilters={setFilters}
          name={paginationLimitName}
          footerActions={footerActions}
        />
      )}
    </>
  )
};

TableAuto.propTypes = {
  headers: PropTypes.array,
  headerColor: PropTypes.oneOf(['light','dark']),
  rows: PropTypes.array,
  checkboxes: PropTypes.bool,
  checked: PropTypes.array,
  pagination: PropTypes.bool,
  showId: PropTypes.bool,
  showPaginationLimitSelect: PropTypes.bool,
  showRowNumber: PropTypes.bool,
  showVerticalBorders: PropTypes.bool,
  tableSmall: PropTypes.bool,
  tableStriped: PropTypes.bool,
  onRowClick: PropTypes.func,
};

